// Client wants manual income entry hidden everywhere (P&L's Income Entry
// panel, Ledger Workspace's "+ Add Income") — income should come only from
// billing. Kept as a single flag rather than deleting the feature, since the
// client may want it back. Flip to true to fully restore it.
export const INCOME_ENTRY_ENABLED = false;

// Returns are the narrow exception the client did ask for: a refund or
// reimbursement that puts money back, most often into the petty cash drawer.
// Mechanically identical to income (a CREDIT transaction, which the petty cash
// balance already adds back — see get_petty_cash_summary), but deliberately
// its own flag so restoring returns never drags the whole Income Entry
// feature back with it. Ledger Workspace only.
export const RETURN_ENTRY_ENABLED = true;
